import React, { useState, useRef, useEffect } from 'react';

import Masonry from 'react-responsive-masonry';
import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import routes from 'app/routes';
import useSize from 'components/Common/Screen/Hooks/useSize';
import aiProgramImg from 'images/new_ui/programs/ai-program.png';
import humanProgramImg from 'images/new_ui/programs/human-program.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Card from './Card';
import Header from './Header';
import BuildProgramModal from '../../List/BuildProgramModal';

export default function Index() {
  const context = useHomeContext();

  const navigate = useNavigate();

  const [existingProgramUrl, setExistingProgramUrl] = useState('');
  const [showBuildProgramModal, setShowBuildProgramModal] = useState(false);

  const [countColumns, setCountColumns] = useState(2);
  const wrapper = useRef(null);
  const size = useSize(wrapper);

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  const onAiProgramStart = () => {
    navigate(routes.members.programs.new_ai.index);
  };

  const onHumanProgramStart = () => {
    axios
      .get(routes.api.programs.possibleStartNewProgram)
      .then((resp) => {
        const response = resp.data.data;

        if (response.possible_start) {
          navigate(routes.members.programs.new.index);
        } else {
          setExistingProgramUrl(response.assign_program_action);
          setShowBuildProgramModal(true);
        }
      });
  };

  useEffect(() => {
    if (size) {
      if (size.width < 576) {
        setCountColumns(1);
      } else {
        setCountColumns(2);
      }
    }
  }, [size]);

  return (
    <div className="content">
      {context && <Breadcrumbs breadcrumbs={breadcrumbs} />}

      <Header className={size !== null && size.width < 750 ? 'flex-column' : 'flex-row'} />
      <section ref={wrapper}>

        <Masonry columnsCount={countColumns} gutter="1rem">
          <div key="ai-program" className={`mb-3 ${size !== null && size.width < 750 ? 'vertical h-100' : ''}`}>
            <Card
              title="AI-Powered Program"
              image={aiProgramImg}
              onClick={onAiProgramStart}
              description={`Start your AI-Powered Program to get a personalized plan 
                and work with your AI coach.`}
            />
          </div>
          <div key="human-program" className={`mb-3 ${size !== null && size.width < 750 ? 'vertical' : ''}`}>
            <Card
              title="Human-Led Program"
              image={humanProgramImg}
              onClick={onHumanProgramStart}
              description={`Start your Human-Led Program and select your 
                topics to work with a human coach.`}
            />
          </div>
        </Masonry>

      </section>

      <BuildProgramModal
        show={showBuildProgramModal}
        onHide={() => setShowBuildProgramModal(false)}
        existingProgramUrl={existingProgramUrl}
      />

    </div>
  );
}
